<div class="offline-page">
    <div class="logo-container">
        <div class="hydrao-logo">
            <img src="assets/logo-smart.svg" />
        </div>
    </div>
    <mat-card appearance="outlined" class="mat-elevation-z0">
        <!-- prettier-ignore -->
        <span i18n="@@login.maintenance.serverDown" class="header">HYDRAO is currently down for maintenance</span>
        <!-- prettier-ignore -->
        <span i18n="@@login.maintenance.backSoon" class="text">We will be back soon. Thanks for your patience.</span>
    </mat-card>



    <div class="version"> v{{version}}&nbsp;-&nbsp;{{hash}}</div>
</div>